"use strict";

angular.module("admin")
	.factory("AdminActionLogsService", ["$http", "ENV", function ($http, ENV) {

		const BASE_URL = ENV.LOGGING_BASE_URL + "api/action-logs";

		function getActionTypes() {
			return $http.get(BASE_URL + "/types");
		}

		function searchActionLogs(criteria) {
			return $http.get(BASE_URL, {
				params: {
					from: criteria.from ? criteria.from.toISOString() : undefined,
					to: criteria.to ? criteria.to.toISOString() : undefined,
					// Tableau sérialisé en paramètres répétés : ?actionTypes=A&actionTypes=B
					actionTypes: criteria.actionTypes && criteria.actionTypes.length ? criteria.actionTypes : undefined,
					operator: criteria.operator || undefined,
					organisationId: criteria.organisationId || undefined,
					search: criteria.organisationId && criteria.search ? criteria.search : undefined
				}
			});
		}

		function getActionLog(id) {
			return $http.get(BASE_URL + "/" + id);
		}

		return {
			getActionTypes: getActionTypes,
			searchActionLogs: searchActionLogs,
			getActionLog: getActionLog
		};
	}
	]);
